import { Container, Grid, InputLabel, Typography } from "@common-ui/ui";

const AssetDetails = ({ asset }) => {
  return (
    <Container component="main" sx={{ mt: 3 }}>
      <Grid container direction="row">
        <Grid item>
          <Grid container direction="column">
            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Asset ID
                </Typography>
                <div style={{ display: "inline-flex", gap: 2 }}>{asset.id}</div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Make
                </Typography>
                <div style={{ display: "inline-flex", gap: 2 }}>
                  {asset.make}
                </div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Model
                </Typography>
                <div style={{ display: "inline-flex" }}>{asset.model}</div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Description
                </Typography>
                <div
                  style={{
                    width: "250px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {asset.description}
                </div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  OEM Serial Number
                </Typography>
                <div style={{ display: "inline-flex" }}>
                  {asset.serial_number}
                </div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Custom Serial Number
                </Typography>
                <div style={{ display: "inline-flex" }}>
                  {asset.custom_serial_number}
                </div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Options
                </Typography>
                <div style={{ display: "inline-flex" }}>{asset.options}</div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Secondary Asset ID
                </Typography>
                <div style={{ display: "inline-flex" }}>
                  {asset.secondary_id}
                </div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Asset Name / Nick Name
                </Typography>
                <div style={{ display: "inline-flex" }}>{asset.name}</div>
              </InputLabel>
            </Grid>

            <Grid item>
              <InputLabel
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography
                  sx={{ m: 0, ml: 2.5 }}
                  fontWeight="800"
                  color="text.primary"
                >
                  Comments
                </Typography>
                <div style={{ display: "inline-flex" }}>{asset.notes}</div>
              </InputLabel>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AssetDetails;
